export enum InvoiceRowAction {
  Edit = "edit",
  View = "view",
  Cancel = "cancel",
  Void = "void",
  As400Reconciliation = "as400-reconciliation",
}
